import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyError } from 'src/app/constants/error';

/** Dialog data: the usual error payload, optionally requesting the English copy
 *  used by MDR operations (mirrors {@link ModalSuccessData}). */
export type ModalErrorData = MyError & { english?: boolean };

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss'],
  standalone: false
})
export class ModalErrorComponent implements OnInit {

  hasToggle: boolean = false;
  title = 'Errore';
  closeLabel = 'CHIUDI';

  constructor(public dialogRef: MatDialogRef<ModalErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public errorDetails: ModalErrorData) { }

  ngOnInit(): void {
    if(this.errorDetails.customDetails) this.hasToggle = true;
    if(this.errorDetails.english) {
      this.title = 'Error';
      this.closeLabel = 'CLOSE';
    }
  }

  close() {
    this.dialogRef.close();
  }

}
